import React from "react";
import { useSelector } from "react-redux";
import { Footer as ACMFooter } from "acm-components";

import { AppState } from "@store";

import type { FooterConfig } from "acm-components";

interface IFooterProps {
  config: FooterConfig;
}

const Footer = ({config}: IFooterProps) => {
  const footerVisibility = useSelector(
    (state: AppState) => state.listing.footerVisibility
  );
  const isVisible = footerVisibility ? "visible" : "hidden";

  return (
    <div style={{ visibility: isVisible, marginTop: "auto" }}>
      <ACMFooter config={config} />
    </div>
  );
};

Footer.displayName = "Footer";

export default Footer;
